import React from "react";

import { CardHeader } from "../../../styles";
import { QueueGroupBody, QueueGroupTitle } from "../../styles";
import { ObservedAt } from "../../../components/ObservedAt";
import { SectionContent } from "../SectionContent";
import { QueueGroupProps } from "./types";

export const QueueGroup = <T,>({
  title,
  section,
  onRetry,
  children,
  testId,
}: QueueGroupProps<T>) => (
  <QueueGroupBody data-testid={testId}>
    <CardHeader>
      <QueueGroupTitle>{title}</QueueGroupTitle>
      {section.state === "available" && (
        <ObservedAt observedAt={section.observedAt} />
      )}
    </CardHeader>
    <SectionContent sectionName={title} section={section} onRetry={onRetry}>
      {children}
    </SectionContent>
  </QueueGroupBody>
);
